import { combineReducers } from "redux";
import { Metric } from "helpers/metrics/types";
import { Order } from "helpers/door-collection";
import { applied } from "./applied";
import { draft } from "./draft";

export type DimensionValue = {
    id: string;
    label: string;
    selected: boolean;
};

export type Dimension = {
    id: string;
    values: DimensionValue[];
    name: string;
    sort: Order;
    selected: boolean;
};

export type Attribute = {
    id: string;
    sort: Order;
    name: string;
    values: DimensionValue[];
    collectionId: string;
    isUserDefined: boolean;
    selected: boolean;
    showLabelInHeader: boolean;
};

export type MetricsState = {
    showAssortmentTotals: boolean;
    showAssortmentPlan: boolean;
    values: Metric[];
};

export type DimensionPanelStateSelectionKind = "attributes" | "dimensions" | "metrics";

export type DimensionsPanelReduxState = {
    showDoors: boolean;
    metrics: MetricsState;
    attributes: Attribute[];
    dimensions: Dimension[];
    collapsedGroupIds: string[];
    delimiter: string;
};

export type DimensionsPanelCompositeReduxState = {
    draft: DimensionsPanelReduxState;
    applied: DimensionsPanelReduxState | null;
};

export const dimensionsPanel = combineReducers<DimensionsPanelCompositeReduxState>({
    applied: applied,
    draft: draft,
});
